module.exports = "<span class='c-disclosure-triangle c-tree__item__view-control'></span>\r\n";